/**
 * Small shared helpers used by the cocktail-bar frontend.
 */

export const isArray = (arr) => Array.isArray(arr);

export const includeKeysFromObject = (obj, keysToInclude = []) => {
    if (!obj || typeof obj !== "object") return {};
    const result = {};
    keysToInclude.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            result[key] = obj[key];
        }
    });
    return result;
};

export const disableConsoleLogging = () => {
    if (typeof window === "undefined") return;
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
};
